import { AnalyticsUserEvent } from '@fruitful/types';
import type { Href } from 'expo-router';
import { router, usePathname } from 'expo-router';
import {
    BackButton,
    BackButtonIconType,
    FruitfulLogoIcon,
    Icon,
    isNonMobileWeb,
    XStack,
} from 'smoothie';

import { TabHeaderButtons } from '../../common/components/TabHeaderButtons';
import { track } from '../../logger/Logger';

const HEADER_SIDE_WIDTH = 150;
const HEADER_SIDE_HEIGHT = 40;

interface OnboardingHeaderProps {
    hasBackButton?: boolean;
    backRoute?: Href;
}

const OnboardingHeader = ({
    hasBackButton,
    backRoute,
}: OnboardingHeaderProps) => {
    const pathname = usePathname();
    const shouldShowBackButton = hasBackButton ?? backRoute != null;
    const onBack =
        backRoute != null
            ? () => {
                  router.navigate(backRoute);
              }
            : undefined;
    const context =
        pathname === '/' || pathname === '/home' ? undefined : 'onboarding';

    return (
        <XStack
            width="100%"
            paddingTop={isNonMobileWeb ? 12 : 0}
            alignItems="center"
            justifyContent="space-between"
        >
            <XStack
                width={HEADER_SIDE_WIDTH}
                height={HEADER_SIDE_HEIGHT}
                alignItems="center"
                justifyContent="flex-start"
            >
                {shouldShowBackButton ? (
                    <BackButton
                        background="gray"
                        iconType={BackButtonIconType.ARROW_LEFT}
                        {...(onBack != null ? { customBackFn: onBack } : {})}
                        onBeforeGoingBack={() => {
                            track(AnalyticsUserEvent.BACK, {
                                pathname,
                                flow: 'Onboarding',
                            });
                        }}
                    />
                ) : null}
            </XStack>
            <Icon icon={FruitfulLogoIcon} size={34} color="$green900" />
            <XStack
                width={HEADER_SIDE_WIDTH}
                height={HEADER_SIDE_HEIGHT}
                alignItems="center"
                justifyContent="flex-end"
            >
                <TabHeaderButtons showMessaging={false} context={context} />
            </XStack>
        </XStack>
    );
};

export default OnboardingHeader;
